// components/EstadoPedidoCell.js
import React from "react";

const clases = {
  CREADO: "estado-creado",
  LE_OK: "estado-le-ok",
  LE_APROBADA: "estado-le-aprobada",
  ASIGNADO: "estado-asignado",
  CARGADO: "estado-cargado",
  DESPACHADO: "estado-despachado",
  "PARCIAL ASIG": "estado-parcialmente-asignado",
  "PARCIAL CARG": "estado-parcialmente-cargado",
  "PARCIAL DESP": "estado-parcialmente-despachado",
};

const EstadoPedidoCell = React.memo(({ estado }) => {
  const clase = clases[estado] || "";
  return <span className={`estado ${clase}`}>{estado}</span>;
});

export default EstadoPedidoCell;
